import { useMemo } from "react";
import type { BankDetails } from "components/job/JobTable/JobBankDetails/types";
import useSearchWords from "hooks/useSearchWords";
import useQuery from "hooks/useQuery";

export interface JobBankDetailsPropsHook {
  searchWords: string[];
  name?: string;
  number?: string;
  sortCode?: string;
}

export default function useJobBankDetailsProps(
  bankDetails: BankDetails
): JobBankDetailsPropsHook {
  const [query] = useQuery("jobs");

  const searchWords = useSearchWords(query);

  const name = useMemo(() => {
    if (!bankDetails?.name) return "No name added";
    if (/^\s*$/.test(bankDetails?.name)) return "No name added";
    return bankDetails?.name;
  }, [bankDetails]);

  const number = useMemo(() => {
    if (!bankDetails?.number) return "No email added";
    if (/^\s*$/.test(bankDetails?.number)) return "No email added";
    return bankDetails?.number;
  }, [bankDetails]);

  const sortCode = useMemo(() => {
    if (!bankDetails?.sortCode) return "No phone added";
    if (/^\s*$/.test(bankDetails?.sortCode)) return "No phone added";
    return bankDetails?.sortCode;
  }, [bankDetails]);

  return {
    searchWords,
    name,
    number,
    sortCode,
  };
}
